<template>
  <v-card class="elevation-5">
    <Notification />
    <Modal
      :show="isModalShow"
      :formType="modalKey"
      :item="modalItem"
      :userRole="userRole"
      @close-modal="closeModalHandler"
    />
    <PickDates :show="isPickDatesModalShow" :item="modalItem" @close-pick-dates-modal="closePickDatesModal" />
    <DataTable
      :subscribers="subscribers"
      :userRole="userRole"
      @open-modal="openModalHandler"
      @open-pick-dates-modal="openPickDatesModal"
    />
  </v-card>
</template>

<script>
import PickDates from '../components/subscribers/PickDates'
export default {
  name: 'Subscribers',
  components: {
    PickDates,
    Notification: () => import('@/components/ui/Notification'),
    Modal: () => import('@/components/subscribers/Modal'),
    DataTable: () => import('@/components/subscribers/DataTable')
  },
  created() {
    this.$store.commit('SAVE_NAV_TITLE', 'Абоненты')
  },
  async mounted() {
    await this.$store.dispatch('GET_USER_INFO')
    if (this.userRole && this.userRole !== 'admin') {
      await this.$store.dispatch('GET_SUBSCRIBERS_LIST', {
        amount: 10,
        page: this.page
      })
    }
  },
  destroyed() {
    this.$store.commit('CLEAR_SUBSCRIBERS')
    this.$store.commit('CLEAR_SEARCH_VALUE')
    this.$store.commit('CLEAR_PAGE_NUMBER')
  },
  data: () => ({
    isModalShow: false,
    isPickDatesModalShow: false,
    modalKey: '',
    modalItem: {}
  }),
  computed: {
    subscribers() {
      return this.$store.state.subscribers.response.subscribers
    },
    page() {
      return this.$store.state.subscribers.page
    },
    userRole() {
      return this.$store.state.user.role
    }
  },
  methods: {
    openModalHandler(key, item) {
      this.modalItem = item
      this.modalKey = key
      this.isModalShow = true
    },
    closeModalHandler() {
      this.isModalShow = false
      this.modalItem = {}
      this.modalKey = ''
    },
    openPickDatesModal(item) {
      this.isPickDatesModalShow = true
      this.modalItem = item
    },
    closePickDatesModal() {
      this.isPickDatesModalShow = false
      this.modalItem = {}
    }
  }
}
</script>
